import React from "react";
import ChatWindow from "./ChatWindow";

export default function AdminAllChats() {
  return (
    <div style={{ height: "80vh", background: "#fff", borderRadius: 12, overflow: "hidden" }}>
      <ChatWindow />
    </div>
  );
}
